/* Seleção de variante, atualização de preço/imagem e feedback de "adicionado" para o card
   `.tpcc-card` (snippets/tp-collection-card.liquid). Usa delegação de eventos em `document`
   para funcionar em qualquer seção que renderize o card, inclusive clones criados por
   carrosséis (ex.: Swiper `loop: true`) depois do carregamento da página. */
(function () {
  if (window.TpccCard) return;
  window.TpccCard = true;

  function formatMoney(cents) {
    if (window.FoxTheme && FoxTheme.Currency && FoxTheme.Currency.formatMoney) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
    }
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getVariants(card) {
    const dataEl = card.querySelector('[data-tpcc-variants]');
    if (!dataEl) return [];
    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      return [];
    }
  }

  function getSelectedOptions(card) {
    const selected = [];
    card.querySelectorAll('[data-tpcc-pill].is-active').forEach((pill) => {
      selected[parseInt(pill.dataset.optionIndex, 10)] = pill.dataset.optionValue;
    });
    return selected;
  }

  function updateAvailability(card, variants, selected) {
    card.querySelectorAll('[data-tpcc-pill]').forEach((pill) => {
      const index = parseInt(pill.dataset.optionIndex, 10);
      const value = pill.dataset.optionValue;
      const possible = variants.some(
        (v) =>
          v.available &&
          v.options[index] === value &&
          v.options.every((opt, i) => i === index || !selected[i] || opt === selected[i])
      );
      pill.classList.toggle('is-unavailable', !possible);
    });
  }

  function updateCard(card) {
    const variants = getVariants(card);
    if (!variants.length) return;

    const selected = getSelectedOptions(card);
    const optionsCount = card.querySelectorAll('[data-option-position]').length;
    updateAvailability(card, variants, selected);

    const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i])) || null;
    const complete = selected.filter(Boolean).length === optionsCount;

    const input = card.querySelector('[data-tpcc-variant-input]');
    const submit = card.querySelector('[data-tpcc-submit]');
    const submitText = card.querySelector('[data-tpcc-submit-text]');

    if (!variant || !complete) {
      if (input) {
        input.value = '';
        input.disabled = true;
      }
      if (submit) submit.disabled = true;
      if (submitText) submitText.textContent = card.dataset.tpccUnavailable || submitText.textContent;
      return;
    }

    if (input) {
      input.value = variant.id;
      input.disabled = !variant.available;
    }
    if (submit) submit.disabled = !variant.available;
    if (submitText) {
      submitText.textContent = variant.available
        ? card.dataset.tpccAddToCart || submitText.textContent
        : card.dataset.tpccSoldOut || submitText.textContent;
    }

    const mediaLink = card.querySelector('[data-tpcc-media-link]');
    const titleLink = card.querySelector('[data-tpcc-title-link]');
    if (variant.url) {
      if (mediaLink) mediaLink.setAttribute('href', variant.url);
      if (titleLink) titleLink.setAttribute('href', variant.url);
    }

    const priceEl = card.querySelector('[data-tpcc-price]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    const compareEl = card.querySelector('[data-tpcc-compare]');
    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compareEl) {
      if (onSale) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    const saleBadge = card.querySelector('[data-tpcc-sale-badge]');
    if (saleBadge) {
      if (onSale) {
        const off = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        saleBadge.textContent = '-' + off + '%';
        saleBadge.hidden = false;
      } else {
        saleBadge.hidden = true;
      }
    }

    const installmentsEl = card.querySelector('[data-tpcc-installments]');
    if (installmentsEl) {
      const n = parseInt(installmentsEl.dataset.installments, 10) || 1;
      installmentsEl.textContent = 'ou ' + n + 'x de ' + formatMoney(Math.round(variant.price / n));
    }

    const imageEl = card.querySelector('.tpcc-card__img');
    if (imageEl && variant.image && imageEl.dataset.currentSrc !== variant.image) {
      imageEl.dataset.currentSrc = variant.image;
      imageEl.classList.add('is-swapping');
      const preload = new Image();
      preload.onload = () => {
        imageEl.removeAttribute('srcset');
        imageEl.src = variant.image;
        imageEl.classList.remove('is-swapping');
      };
      preload.src = variant.image;
    }
  }

  document.addEventListener('click', (event) => {
    const pill = event.target.closest('[data-tpcc-pill]');
    if (!pill) return;
    const card = pill.closest('[data-tpcc-card]');
    if (!card) return;

    const index = pill.dataset.optionIndex;
    card.querySelectorAll(`[data-tpcc-pill][data-option-index="${index}"]`).forEach((other) => {
      const isThis = other === pill;
      other.classList.toggle('is-active', isThis);
      other.setAttribute('aria-pressed', isThis ? 'true' : 'false');
    });

    updateCard(card);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    const card = form.closest('[data-tpcc-card]');
    if (!card) return;

    const submit = card.querySelector('[data-tpcc-submit]');
    const submitText = card.querySelector('[data-tpcc-submit-text]');
    if (!submit || !submitText || submit.disabled) return;

    const original = submitText.textContent;
    const addedText = card.dataset.tpccAddedText || original;
    window.setTimeout(() => {
      submitText.textContent = addedText;
      submit.classList.add('is-added');
      window.setTimeout(() => {
        submitText.textContent = original;
        submit.classList.remove('is-added');
      }, 1800);
    }, 500);
  });

  document.querySelectorAll('[data-tpcc-card]').forEach((card) => {
    if (card.querySelector('[data-tpcc-pill]')) updateCard(card);
  });
})();
